import { Injectable } from "@angular/core";
import { ThirdPartyRepository } from "../../../domain/repositories/thirdparty.repository";
import { LocationImplementationRepositoryMapper } from "./mappers/location-repository.mapper";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { IpImplementationRepositoryMapper } from "./mappers/ip-repository.mapper";
import { IpEntity } from "./entities/ip.entity";
import { IpModel } from "../../../domain/models/thirdparty/ip.model";
import { LocationModel } from "../../../domain/models/thirdparty/location.model";
import { LocationEntity } from "./entities/location.entity";
import { options } from "@fullcalendar/core/preact.js";


@Injectable({
    providedIn: 'root',
})
export class ThirdPartyImplementationRepository extends ThirdPartyRepository {
    
    ip = new IpImplementationRepositoryMapper();
    location = new LocationImplementationRepositoryMapper();
    header = new HttpHeaders({
        'No-Auth': 'true'
    });

    urlIp = environment.baseUrl;
    urlLocation = environment.baseUrl;
    constructor(private http: HttpClient) {
        super();
    }

    override getIp(): Observable<IpModel> {
        return this.http.get<IpEntity>(`${this.urlIp}`,{headers:this.header})
        .pipe(map(this.ip.mapFrom));
    }
    
    override getIpLocation(params: {ip: string}): Observable<LocationModel> {
        return this.http.get<LocationEntity>(`${this.urlLocation}/?ip=${params.ip}`,{headers:this.header})
        .pipe(map(this.location.mapFrom));
    }
}